export default "__VITE_ASSET__BAN3eYYW__"